/**
 * @generated SignedSource<<260b771f871d9dea1a7ecac8aeededdc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLocationsModule_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedBestsellingDesignsCarousel_user" | "HpSharedExcellentValuesCarousel_user" | "HpSharedMostSavedItemsCarousel_user">;
  readonly " $fragmentType": "HpSharedLocationsModule_user";
};
export type HpSharedLocationsModule_user$key = {
  readonly " $data"?: HpSharedLocationsModule_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationsModule_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedLocationsModule_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedMostSavedItemsCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedExcellentValuesCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedBestsellingDesignsCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7cbc142dc27745b21832c1173dbd381b";

export default node;
